import axios from 'axios'

export default {
  // ======================================================================
  // ==========================List Management=============================
  // ======================================================================
  list (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/retention')
        .then(({ data }) => {
          context.commit('LIST', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  // ==========================Socket Updates==============================
  created (context, opts) {
    axios
      .get(`/api/retention/${opts}`)
      .then(({ data }) => {
        if (data.id) {
          context.commit('LIST_ADD', data)
        }
      }).catch(() => {
      })
  },
  updated (context, opts) {
    axios
      .get(`/api/retention/${opts}`)
      .then(({ data }) => {
        if (data.id) {
          context.commit('LIST_UPDATE', data)
          if (data.id === context.state.current.id) {
            context.commit('CURRENT', data)
          }
        }
      }).catch(() => {
      })
  },
  destroyed (context, opts) {
    // always try to remove from list
    context.commit('LIST_REMOVE', opts)
    if (opts === context.state.current.id) {
      context.commit('CURRENT', null)
    }
  },
  // ===========================List Edits===============================
  add (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/retention', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  delete (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/retention/${opts}`)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  // ======================================================================
  // ==========================Item Management=============================
  // ======================================================================
  detail (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/retention/${id}`)
        .then(({ data }) => {
          context.commit('CURRENT', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  update (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/retention/${context.state.current.id}`, context.state.update)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  }
}
